import styles from './Spinner.module.css';

interface SpinnerProps {
  hasWrapper?: boolean;
}

const SpinnerComponent = (
  <img 
    src="/beatly-logo.png" 
    alt="Loading" 
    className={styles.spinnerLogo} 
  />
);

export function Spinner({ hasWrapper = false }: SpinnerProps) {
  if (hasWrapper) {
    return <div className={styles.spinnerWrapper}>{SpinnerComponent}</div>;
  }

  return SpinnerComponent;
}
